/* eslint-disable no-plusplus */
import React from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"

const Breadcrumbs = props => {
  const { breadcrumbs, className } = props
  return (
    <div className={`${className} breadcrumbs`}>
      {breadcrumbs.length > 0 && (
        <ol
          className={`breadcrumbs-list`}
          itemScope
          itemType="https://schema.org/BreadcrumbList"
        >
          {breadcrumbs.map((breadcrumb, i) => {
            return (
              <li
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
                key={`breadcrumb-${i + 1}`}
              >
                {i + 1 < breadcrumbs.length ? (
                  <Link
                    itemProp="item"
                    to={breadcrumb.url}
                    activeClassName="active"
                  >
                    <span itemProp="name">{decodeURI(breadcrumb.text)}</span>
                    <meta itemProp="position" content={i++ + 1} />
                  </Link>
                ) : (
                  <a itemProp="item">
                    <span itemProp="name">{decodeURI(breadcrumb.text)}</span>
                    <meta itemProp="position" content={i++ + 1} />
                  </a>
                )}
              </li>
            )
          })}
        </ol>
      )}
    </div>
  )
}

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.array,
  className: PropTypes.string,
}

export default Breadcrumbs
